import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import Tooltip from 'rc-tooltip'
import _ from 'common-tools/LodashHelper'

export class ToolTip extends React.Component {
  static pt = {
    color: pt.string,
    toolTip: pt.string,
    placement: pt.string,
    overlayClassName: pt.string,
    htmlToolTip: pt.bool
  }

  static defaultProps = {
    placement: 'top',
    htmlToolTip: false,
    trigger: ['hover']
  }

  render () {
    const { children, color, toolTip, placement, overlayClassName, htmlToolTip, trigger } = this.props

    const toolTipColor = _.replace(color, 'outline-', '')
    return (
      <Tooltip
        placement={placement}
        trigger={trigger}
        overlayClassName={`${overlayClassName || ''} ${toolTipColor || ''}`}
        overlay={htmlToolTip ? <span dangerouslySetInnerHTML={{ __html: toolTip }}></span> : toolTip}>
        {children}
      </Tooltip>
    )
  }
}
